import {
  SimpleForm,
  NumberInput,
  Toolbar,
  SaveButton,
  Button,
  maxValue,
  required,
} from "react-admin";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useNotify } from "react-admin";
import { integerOnly } from "../validators";
const COUNT_BINS_MAX = 10000;

export const OutletInventoryCreate = () => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const notify = useNotify();
  const outletId = new URLSearchParams(search).get("outletId")!;

  const onSubmit = async (values: any) => {
    const token = localStorage.getItem("kc_token");
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/outlet-inventory/${outletId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` }),
          },
          body: JSON.stringify(values),
        }
      );
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || res.statusText);
      }
      notify("Inventaire créé", { type: "success" });
      navigate(`/outlet-inventory/details/${outletId}`);
    } catch (err: any) {
      notify(err.message || "Erreur lors de la création", { type: "error" });
    }
  };

  return (
    <>
      <h2>Ajouter un inventaire exutoire</h2>
      <SimpleForm
        onSubmit={onSubmit}
        toolbar={
          <Toolbar>
            <SaveButton />
            <Button
              component={Link}
              variant="outlined"
              color="secondary"
              size="large"
              to={`/outlet-inventory/details/${outletId}`}
              sx={{ ml: 2, pl: 4 }}
            >
              Annuler
            </Button>
          </Toolbar>
        }
      >
        <NumberInput
          source="fullBinsCount"
          label="Caisses pleines"
          validate={[
            required("La quantité de caisse est requise"),
            maxValue(COUNT_BINS_MAX, `Maximum ${COUNT_BINS_MAX}`),
            integerOnly("Doit être un nombre décimal"),
          ]}
        />
        <NumberInput
          source="emptyBinsCount"
          label="Caisses vides"
          validate={[
            required("La quantité de caisse est requise"),
            maxValue(COUNT_BINS_MAX, `Maximum ${COUNT_BINS_MAX}`),
            integerOnly("Doit être un nombre décimal"),
          ]}
        />
      </SimpleForm>
    </>
  );
};
